/**
 * 企业版计量方式，与 oversea-pay 的 EnterpriseBillingMode 枚举对齐。
 * 空值 / 未知值回退为处理人数，保持存量订单的原语义。
 */
export type BillingMode = 'PROCESSED_BUYER' | 'ORDER' | 'BUYER_MESSAGE';

const BILLING_MODES: BillingMode[] = ['PROCESSED_BUYER', 'ORDER', 'BUYER_MESSAGE'];

export const resolveBillingMode = (billingMode?: string | null): BillingMode => {
  return BILLING_MODES.includes(billingMode as BillingMode)
    ? (billingMode as BillingMode)
    : 'PROCESSED_BUYER';
};

/**
 * 不限量额度：企业版定制套餐历史口径 handleNum=0，新体系口径 -1。
 */
export const isUnlimitedHandleNum = (handleNum?: number | null): boolean => {
  return handleNum === 0 || handleNum === -1;
};
